function cov_26qrws379x() {
  var path = "/app/src/components/logo/components/logo-en-gray-on-transparent/index.ts";
  var hash = "23997592483e83dbf5d1827f40d2aac8f13c9561";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-gray-on-transparent/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "23997592483e83dbf5d1827f40d2aac8f13c9561"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26qrws379x = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_26qrws379x();
export { LogoEnGrayOnTransparent } from './logo-en-gray-on-transparent';